// Export all form styles for easy importing
import * as FormStyles from './base.styles';

export default FormStyles;
